module.exports = __webpack_public_path__ + "img/barva-beige.d5dffe2.webp";